import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ISubTeamDTO } from "../../../../../../api-services/football/admin/manage-football-team-service";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";

export interface ITeamEditOption {
  teamId: number;
  subTeamId: number;
  subTeamData: ISubTeamDTO;
}

interface ITeamEdit {
  subTeamEditResponseStatus: StatusEnum;
}

const initialState: ITeamEdit = {
  subTeamEditResponseStatus: StatusEnum.Idle,
};

export const subTeamEdit = createAsyncThunk("manage/subTeamEdit", async (options: ITeamEditOption, thunkAPI) => {
  try {
    const subTeamEditResponse = await manageFootballTeamService.editSubTeam(
      options.teamId,
      options.subTeamId,
      options.subTeamData
    );
    return subTeamEditResponse;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

const manageSubTeamEditSlice = createSlice({
  name: "subTeamEdit",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(subTeamEdit.pending, (state) => {
        state.subTeamEditResponseStatus = StatusEnum.Loading;
      })
      .addCase(subTeamEdit.fulfilled, (state) => {
        state.subTeamEditResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamEdit.rejected, (state) => {
        state.subTeamEditResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageSubTeamEditSlice.reducer;
